import SingleSelectQuestionTemplate from '~/pages/anatomyV2/libs/components/SingleSelectQuestionTemplate'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 6

const DoomscrollingTimeAnatomyV2 = (props: TPageProps) => (
  <SingleSelectQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.doomscrollingTime.title"
    options={[
      {
        key: 'lessThanOneHour',
        i18nKey: 'onboarding.doomscrollingTime.options.lessThanOneHour',
      },
      {
        key: 'oneToThreeHours',
        i18nKey: 'onboarding.doomscrollingTime.options.oneToThreeHours',
      },
      {
        key: 'mostOfMyFreeTime',
        i18nKey: 'onboarding.doomscrollingTime.options.mostOfMyFreeTime',
      },
    ]}
    question="How much time do you spend doomscrolling?"
  />
)

export default DoomscrollingTimeAnatomyV2
